import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import * as mws from '@/shared/MwsViewModels';
import template from './content-page-header-panel.vue';
import { ReactInVue } from 'vuera';
import ContentPageHeaderReact from '../../../react/rebrand-lite/panels/ContentPageHeaderPanel';
import FundDailyPricesShortlistMixin from '../../../shared/components/fund-daily-prices/FundDailyPricesShortlistMixin';
import EventBus from '../../../shared/EventBus';

@Component({
  mixins: [template],
  components: {
    ContentPageHeaderReact: ReactInVue(ContentPageHeaderReact),
  },
})

// IMPORTANT: This is now a React panel, but all of the below 
// logic is required for the Daily Prices Shortlist to work and
// cannot be moved to a more appropriate panel due to reliance
// on this panel's nav links.

export default class ContentPageHeaderPanel extends Mixins(FundDailyPricesShortlistMixin) {
  private width = 0;
  private maxNavHeight = '';
  shortlistCounter: number = 0;

  @Prop()
  data: mws.ContentPageHeaderPanel;

  mounted() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
    this.handleShortlistCounter();
    Vue.nextTick(() => {
      this.doesShortlistNavItemExist();
      this.sendDailyPricesPageUrl();
    });
  }

  destroyed() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  get navLinks(): mws.ILink[] {
    return (this.data.links || []).slice(0, 5);
  }

  isCurrent(url: string): boolean {
    const resource = this.$route.fullPath;
    return url.endsWith(resource);
  }

  private resizeHandler() {
    this.width = window.innerWidth;
    let navHeadings = this.$refs.navHeading as Element[];
    if(navHeadings) {
      let maxHeight = Math.max(...navHeadings.map(n => n.clientHeight));
      if(this.width < 800){
        this.maxNavHeight = `${maxHeight - 30}px`;
      } else {
        this.maxNavHeight = `${maxHeight}px`;
      }
    }
  }

  private handleShortlistCounter() {
    this.shortlistCounter = this.getCurrentRegionAndChannelShortlistCount();

    EventBus.$on('dp-shortlist-updated', async (toAdd: number) => {
      this.shortlistCounter += toAdd;
    });
  }

  private doesShortlistNavItemExist() {
    let exists = this.navLinks.filter(l => l.linkText.toLowerCase().includes(this.shortlistNavHeadingPart)).length > 0;
    if (exists) {
      EventBus.$emit('dp-shortlist-navitem-exist');
    }
  }

  private sendDailyPricesPageUrl() {
    let navLink = this.navLinks.filter(l => l.linkText.toLowerCase().includes(this.dailyPricesNavHeadingPart))[0];
    if (navLink) {
      EventBus.$emit('dp-dailyPrices-navitem-exist', `<a href=${navLink.url}>${navLink.linkText}</a>`);
    }
  }

  isItShortlistNavItem(navItem: mws.ILink) {
    return navItem.linkText.toLowerCase().includes(this.shortlistNavHeadingPart);
  }

  get getShortlistCounter() {
    return this.shortlistCounter;
  }
}